import { Injector } from '@angular/core';
import { deleteShapes } from '../../../../../cross-team-shared/annotation/shared/state/layers/shape-layer-state';
import { ShapeState2D } from '../../../../../cross-team-shared/annotation/shared/state/shape-state';
import { TrackingEvent } from '../../../../../cross-team-shared/event-tracking/event-utils';
import { addUngroupedShape } from '../../../../../cross-team-shared/state/shape.state';
import { OVERLAY_RECTANGLE_INDEX } from '../../../../../team-apis/core/reserved-shape-indexes';
import { Point2D } from '../../../../../team-apis/otterdam/answers/shape-typings';
import { ImageBoundsService } from '../../edit/image-bounds.service';
import { AbstractDragHandler2D } from './abstract-drag-handler-2d';

export class OverlayRectangleDragHandler extends AbstractDragHandler2D {
  private startPoint = this.getImagePoint();
  private shapeStore = this.store('vectorOverlay')('shapes')(
    OVERLAY_RECTANGLE_INDEX,
  );
  private imageBoundsService: ImageBoundsService;

  constructor(
    initialEvent: MouseEvent,
    injector: Injector,
    showDimensions: boolean,
    protected override event?: TrackingEvent,
  ) {
    super(initialEvent, injector);
    this.imageBoundsService = injector.get(ImageBoundsService);

    const shape: ShapeState2D = {
      type: 'rectangle',
      index: OVERLAY_RECTANGLE_INDEX,
      transparent: true,
      showDimensions,
      tags: {},
      dynamic_tags: {},
      key_locations: [
        {
          frame_number: 0,
          points: buildRectanglePoints(this.startPoint, this.startPoint),
          visibility: 1,
        },
      ],
    };
    addUngroupedShape(shape, this.store('vectorOverlay'));
    if (event) {
      this.shouldTrackBatchEvents = true;
    }
  }

  protected onDrag(dragPoint: Point2D) {
    // @ts-ignore -- fix me
    this.shapeStore('key_locations')(0)('points').set(
      // @ts-ignore -- fix me
      buildRectanglePoints(
        this.startPoint,
        this.imageBoundsService.boundPoints(dragPoint),
      ),
    );
  }

  protected override complete() {
    if (this.event) {
      const batchValues = this.getBatchValues();
      this.shellConnector.trackEvent({
        ...this.event,
        ...batchValues.buildEventTrackingValue(),
      });
    }
  }

  protected override cleanUp() {
    deleteShapes([OVERLAY_RECTANGLE_INDEX], this.store('vectorOverlay'));
    super.cleanUp();
  }
}

function buildRectanglePoints([x1, y1]: Point2D, [x2, y2]: Point2D): Point2D[] {
  return [
    [x1, y1],
    [x2, y1],
    [x2, y2],
    [x1, y2],
  ];
}
